<template>
  <div class="content-wrap dashboard-widgets">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12">
          <div class="card" v-if="loading">Loading...</div>
          <div class="card" v-else>
            <div class="card-header media" style="display: flex; align-items: center">
              <div class="media-left">
                <font-awesome-icon :icon="widgetIcon" />
              </div>
              <div class="media-body">
                <h3 class="card-title">{{ widgetTitle }}</h3>
                <nav class="nav card-nav">
                  <slot name="dashboardSidebarNav" />
                  <a
                    v-if="enableFilters"
                    href="#"
                    class="nav-link card-header-btn py-0 dashboard-sidenav-link"
                    @click.prevent="toggleFilterPanel"
                  >
                    <span style="padding-right: 0.5rem">
                      {{ localShowFilterPanel ? 'Hide Filters' : 'Show Filters' }}
                    </span>
                    <font-awesome-icon :icon="['fas', 'filter']" />
                  </a>
                </nav>
              </div>
            </div>
            <div v-if="enableFilters && localShowFilterPanel" class="card-body card-options p-0">
              <div class="customize-panel">
                <h4>Filters</h4>
                <div class="row">
                  <div class="col-sm-12">
                    <slot name="filters" />
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div v-if="error" class="alert alert-danger">{{ error }}</div>
              <slot name="content" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    widgetIcon: { required: true, type: [String, Array] },
    widgetTitle: { required: true, type: String },
    widgetId: { required: true, type: String },
    enableFilters: { default: true, type: Boolean },
    showFilterPanel: { default: false, type: Boolean },
    error: { type: String, default: null },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      localShowFilterPanel: this.showFilterPanel
    };
  },
  methods: {
    toggleFilterPanel() {
      this.localShowFilterPanel = !this.localShowFilterPanel;
    }
  }
};
</script>

<style scoped>
</style>
